import { render, staticRenderFns } from "./MultiValueIndicator.vue?vue&type=template&id=06482c54&scoped=true"
import script from "./MultiValueIndicator.vue?vue&type=script&lang=js"
export * from "./MultiValueIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06482c54",
  null
  
)

export default component.exports